import { create } from 'zustand';

import type { ToastType } from '@/components/shared/ui/toasts/types';

type ToastState = {
  toasts: ToastType[];
  openToast: (toastState: ToastType) => void;
  closeToast: (id: string) => void;
};

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  openToast: (toastState) => {
    return set((state) => ({
      toasts: [...state.toasts, toastState],
    }));
  },
  closeToast: (id) =>
    set((state) => {
      return {
        toasts: state.toasts.filter((toast) => toast.id !== id),
      };
    }),
}));
